const ONE_DAY = 1000 * 60 * 60 * 24;
export const ALLOWED_TIMEZONE_UPDATE_PERIOD = ONE_DAY;

export const isTimezoneUpdatedInPast24Hours = (scheduleResponse) => {
	if (!scheduleResponse || !scheduleResponse.updatedAt) return false;

	return timezoneUpdatedAgo(scheduleResponse.updatedAt) < ALLOWED_TIMEZONE_UPDATE_PERIOD;
};

export const timeToNextReset = (lastUpdatingDate) => {
	return ALLOWED_TIMEZONE_UPDATE_PERIOD - timezoneUpdatedAgo(lastUpdatingDate);
}

export const timezoneUpdatedAgo = (lastUpdatingDate) => {
	return new Date() - new Date(lastUpdatingDate);
}

export function approveTimezoneChange(doNotShowAgain = false) {
	localStorage.setItem("approveTimezoneChange", !doNotShowAgain);
}

export function showTimezoneChangeWarning() {
	return localStorage.getItem("approveTimezoneChange") !== "false";
}
